<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 650px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  overflow: hidden;
  .line {
    height: 650px;
    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <!-- <boxWrap :name="name"> -->
    <div class="table">
      <div class="line">
        <div class="main"></div>
      </div>
    </div>
  <!-- </boxWrap> -->
</template>

<script>
// import boxWrap from '../common/boxWrap';
// import bar from 'components/dashboard/bar'
import echarts from "echarts";
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '',
      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
      tableData: [
        { name: '百色芒果', scale: '120.16万亩', output: '35.02亿', production: '672900吨', listed: '夏季' },
        { name: '百色番茄', scale: '24.25万亩', output: '9.5亿', production: '850000吨', listed: '全年' },
        { name: '田东香芒', scale: '23万亩', output: '7.6亿', production: '58000吨', listed: '夏季' },
        { name: '凌云牛心李', scale: '5万亩', output: '2.4亿', production: '60000吨', listed: '秋季' },
        { name: '德保山楂', scale: '8万亩', output: '1.8亿', production: '45000吨', listed: '夏季' },
        { name: '西林沙塘桔', scale: '16.6万亩', output: '12亿', production: '400000吨', listed: '秋季' },
        { name: '田阳香芒', scale: '39.7万亩', output: '11.3亿', production: '236000吨', listed: '夏季' },
        { name: '平果火龙果', scale: '2.3万亩', output: '8亿', production: '8000吨', listed: '夏季' },
        { name: '隆林板栗', scale: '13.78万亩', output: '0.28亿', production: '4000吨', listed: '秋季' },
        { name: '凌云白毫茶', scale: '12.6万亩', output: '4.51亿', production: '5412吨', listed: '春季' }
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    // boxWrap,
    swiper,
    swiperSlide
    // bar
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      // for (var i = 0; i < 7; i++) {
      //   this.data[i] = this.data[i]
      //   // this.data[i] = Math.floor(Math.random() * 100);
      // }
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".line .main"));
      this.myChart.setOption({
        animation: true,
        xAxis: {
          grid: {
            top: 0
          },
          data: [
            "百色芒果",
            "田东香芒",
            "百色番茄",
            "凌云牛心李",
            "德保山楂",
            "西林沙塘桔",
            "田阳香芒",
            "平果火龙果",
            "隆林板栗",
            "凌云白毫茶"
          ],
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: "#fff",
            fontSize: 12,
            rotate: 30
          }
        },
        yAxis: {
          name: '百万',
          nameTextStyle: {
            color: "#fff",
            fontSize: 12
          },
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#fff",
            fontSize: 12
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#0177d4"
            }
          }
        },
        series: [
          {
            type: "line",
            barWidth: 18,
            // itemStyle: {
            //   normal: {
            //     color: new echarts.graphic.LinearGradient(
            //       0,
            //       0,
            //       0,
            //       1,
            //       [
            //         {
            //           offset: 0,
            //           color: "rgba(232,159,31,1)"
            //         },
            //         {
            //           offset: 0.8,
            //           color: "rgba(241,100,30,1)"
            //         }
            //       ],
            //       false
            //     )
            //   }
            // },
            data: this.data
          }
        ]
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    var self = this;
    self.chart();
    self.init();
    this.timer = setInterval(() => {
      // 某些定时器操作
      self.getData()
    }, 3000);
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?5275c5f1